exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.padding-prefix input[data-v-ba01e772] {\n    padding-left: 8px !important;\n}\n", ""]);

// exports
